import axios from 'axios';

export const Actions = {
  get: async (url) => await axios.get(url).then(({ data }) => data),
  post: async (url, data) => await axios.post(url, data).then(({ data }) => data),
};
